import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EncoderService {
  encode<T>(data: T): string {
    return btoa(JSON.stringify(data));
  }

  decode<T>(data: string): T {
    return JSON.parse(atob(data)) as T;
  }
}
